export const isEmailAddress = (value: string): boolean => {
  return /^\S+@\S+\.\S+$/.test(value) || value?.startsWith('mailto:');
};
